import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import PageWrapper from "../components/PageWrapper/PageWrapper";
import AddressForm from "../components/address/AddressForm";

const AddAddress = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const handleAddressSuccess = () => {
    enqueueSnackbar("Address added successfully", { variant: "success" });
    history.replace("/");
  };

  return (
    <PageWrapper hideNav>
      <div className="mx-auto w-full max-w-2xl px-4 py-4 sm:px-6 sm:py-6">
        <h1 className="text-2xl sm:text-3xl font-bold mb-6">Add Address</h1>
        <div className="rounded-xl bg-white shadow-md border border-gray-100 overflow-hidden">
          <AddressForm onSuccess={handleAddressSuccess} hideCancel={true} />
        </div>
      </div>
    </PageWrapper>
  );
};

export default AddAddress;
